import seaways from 'seaways'
import { axiosClient } from '../../services/axios-client'

const http = seaways.createClient(axiosClient)

http.all = { method: 'get', path: '/projects/get' }
http.create = { method: 'post', path: '/projects/create' }
http.update = { method: 'put', path: '/projects/{projectId}/update' }
http.remove = { method: 'delete', path: '/projects/{projectId}/archive' }
http.restore = { method: 'patch', path: '/projects/{projectId}/unarchive' }

async function all() {
  return (await http.all()).data
}

async function create(name) {
  const requestOptions = {
    data: {
      name
    }
  }
  return (await http.create(requestOptions)).data
}

async function update({ projectId, projectName }) {
  const requestOptions = {
    pathParams: { projectId },
    data: {
      name: projectName
    }
  }
  return (await http.update(requestOptions)).data
}

async function remove({ projectId }) {
  return (await http.remove({ pathParams: { projectId } })).data
}
async function restore({ projectId }) {
  return (await http.restore({ pathParams: { projectId } })).data
}

export default {
  all,
  create,
  update,
  remove,
  restore
}
